module.exports = __webpack_public_path__ + "img/LOWA_2025.eeaf8c38.png";